'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n  padding: ', ';\n  fill: ', ';\n\n  ', '\n'], ['\n  width: ', ';\n  height: ', ';\n  padding: ', ';\n  fill: ', ';\n\n  ', '\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var SVGContainer = _styledComponents2.default.svg(_templateObject, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.padding || '0';
}, function (props) {
  return props.color || props.theme.color_gray;
}, function (props) {
  if (props.isCircle) {
    return '\n        animation-play-state: running; \n        animation-delay: 0s; \n        background: none;\n      ';
  }
});
var LoadingCircle = function (_PureComponent) {
  _inherits(LoadingCircle, _PureComponent);
  function LoadingCircle() {
    _classCallCheck(this, LoadingCircle);
    return _possibleConstructorReturn(this, (LoadingCircle.__proto__ || Object.getPrototypeOf(LoadingCircle)).apply(this, arguments));
  }
  _createClass(LoadingCircle, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SVGContainer, Object.assign({}, this.props, {
        viewBox: '0 0 100 100'
      }), _react2.default.createElement('path', {
        stroke: 'none',
        d: 'M10 50A40 40 0 0 0 90 50A40 44 0 0 1 10 50',
        transform: 'rotate(342.627 50 52)',
        style: {
          animationPlayState: 'running',
          animationDelay: '0s'
        }
      }, _react2.default.createElement('animateTransform', {
        attributeName: 'transform',
        type: 'rotate',
        calcMode: 'linear',
        values: '0 50 52;360 50 52',
        keyTimes: '0;1',
        dur: '0.7s',
        begin: '0s',
        repeatCount: 'indefinite',
        style: {
          animationPlayState: 'running',
          animationDelay: '0s'
        }
      })));
    }
  }]);
  return LoadingCircle;
}(_react.PureComponent);
exports.default = LoadingCircle;